<template>
  <BatteryIcon v-if="type === 'icon'"
    :disabled="disabled"
    :parent-disconnected="gatewayOrDeviceNotConnected"
    :status="status"
  />
  <span v-else-if="type === 'label'">
    {{ label }}
  </span>
</template>
<script setup lang="ts">
import { qx_Door, qx_eDeviceConnectionStatus_enum, qx_Sensor } from '@/graphql/types';
import { isOfflineLockDoor } from '@/models/door/utilities/is-offline-lock-door';
import { doorHasWirelessLock } from '@/models/door/utilities/door-has-wireless-lock';
import { getBatteryIconStatus } from '@/constants/battery';
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  item: qx_Sensor | qx_Door,
  type?: 'icon' | 'label' // smartIconValidator()
}>(), {
  type: 'icon'
});

const isWiredDoor = computed(() => props.item.__typename === 'qx_Door' && !doorHasWirelessLock(props.item)
  && !isOfflineLockDoor(props.item));

const disabled = computed(() => {
  return !props.item?.enabled || props.item?.disabledByLicense;
});

const status = computed(() => {
  if (isWiredDoor.value) {
    return false;
  }
  return props.item?.batteryLevel;
});

const gatewayOrDeviceNotConnected = computed(() => {
  const gatewayConnectionStatus = props.item?.gatewayConnectionStatus || props.item?.device.gateway?.connectionStatus
  const deviceConnectionStatus = (props.item?.deviceConnectionStatus || props.item?.device?.connectionStatus) === qx_eDeviceConnectionStatus_enum.Connected;
  const fullyConnected =  gatewayConnectionStatus && deviceConnectionStatus
  return !(fullyConnected || false);
});

const label = computed(() => {
  if (isWiredDoor.value) {
    return "None";
  }
  return getBatteryIconStatus(status.value, gatewayOrDeviceNotConnected.value, !disabled.value)?.tooltip || '';
});
</script>
